/* @flow weak */
import React from 'react';
import TopicsSectionTitle from 'groups/components/TopicsSectionTitle.jsx';

const Section = (props) => (
  <section className="GroupsNav-section">
    {
      props.title && (
        <TopicsSectionTitle className="GroupsNav-section-title">
          {props.title}
        </TopicsSectionTitle>
      )
    }

    {props.children}
  </section>
);

Section.propTypes = {
  title: React.PropTypes.string,
  children: React.PropTypes.node.isRequired,
};

export default Section;



// WEBPACK FOOTER //
// ./src/groups/components/GroupsNav-Section.js